import './NotesEditor.css';
import React from 'react';
import classname from '@search/classname/src';
import { Modal, Button } from '@vtblife/uikit';
import { Size, Textarea } from '@vtblife/uikit/legacy';
import { ENTER } from '../../../constants/keycode';

const cn = classname.bind(null, 'NotesEditor');

export function NotesEditor({
    noteTextInitial,
    noteSubmit,
    noteDelete,
    onClose,
    maxLength = 300
}: {
    noteDelete?(): void;
    noteSubmit: (data: { note?: string }) => void;
    maxLength?: number;
    onClose?(): void;
    noteTextInitial?: string;
}) {
    const [ noteText, setNoteText ] = React.useState(noteTextInitial ?? '');

    const isError = noteText.length > maxLength;

    return (
        <Modal
            opened
            size={Size.Large}
            onClose={onClose}
            swipeToClose={false}
        >
            <Modal.Title>Ваша заметка</Modal.Title>
            <div className={cn('body')}>
                <div className={cn('group')}>
                    <Textarea
                        rows={4}
                        data-scroll-lock-ignore
                        maxLength={maxLength}
                        isError={isError || (Boolean(noteTextInitial?.length) && noteText.trim().length === 0)}
                        onKeyPress={e => e.key === ENTER ? e.stopPropagation() : undefined}
                        onChange={setNoteText}
                        fullWidth
                        required
                        autoFocus
                        value={noteText}
                        placeholder='Текст заметки (будет виден только вам)'
                    />
                    <div className={cn('lable', { isError })}>{maxLength} - максимальное число допустимых символов</div>
                </div>
                <div className={cn('group')}>
                    <Button
                        fullWidth
                        variant='primary'
                        disabled={isError || noteText.trim().length === 0}
                        onClick={() => noteSubmit({ note: noteText || undefined })}
                        dataTest='offer-save-notes'
                    >Сохранить заметку</Button>
                    {Boolean(noteTextInitial?.length) && (
                        <Button
                            fullWidth
                            dataTest='offer-remove-notes'
                            variant='secondary'
                            disabled={isError}
                            onClick={noteDelete}
                        >Удалить заметку</Button>
                    )}
                </div>
            </div>
        </Modal>
    );
}
